export default __webpack_public_path__ + "img/inner-spaces-8d2fcf.svg";